"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var SvgEbCog = function SvgEbCog(props) {
  return _react["default"].createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _react["default"].createElement("defs", null, _react["default"].createElement("path", {
    id: "eb-cog_svg__a",
    d: "M20 16.348A3.657 3.657 0 0 1 23.652 20 3.657 3.657 0 0 1 20 23.652 3.657 3.657 0 0 1 16.348 20 3.657 3.657 0 0 1 20 16.348zm0 6.26A2.612 2.612 0 0 0 22.609 20 2.612 2.612 0 0 0 20 17.391 2.612 2.612 0 0 0 17.391 20 2.612 2.612 0 0 0 20 22.609zm11.522-4.693c.27.023.478.248.478.52v3.13a.52.52 0 0 1-.478.52l-2.969.247a8.788 8.788 0 0 1-.857 2.064l1.926 2.275a.522.522 0 0 1-.03.707l-2.213 2.214a.521.521 0 0 1-.706.03l-2.276-1.926a8.806 8.806 0 0 1-2.064.857l-.248 2.969a.522.522 0 0 1-.52.478h-3.13a.521.521 0 0 1-.52-.478l-.247-2.969a8.806 8.806 0 0 1-2.064-.857l-2.277 1.926a.522.522 0 0 1-.705-.03l-2.214-2.214a.522.522 0 0 1-.03-.706l1.926-2.275a8.788 8.788 0 0 1-.857-2.064l-2.969-.248a.521.521 0 0 1-.478-.52v-3.13c0-.272.208-.497.478-.52l2.97-.248c.195-.72.482-1.412.856-2.064l-1.925-2.276a.522.522 0 0 1 .029-.706l2.213-2.213a.522.522 0 0 1 .706-.03l2.276 1.926a8.806 8.806 0 0 1 2.064-.857l.248-2.969a.522.522 0 0 1 .52-.478h3.13c.272 0 .497.208.52.478l.247 2.97c.72.195 1.412.483 2.064.856l2.277-1.926a.523.523 0 0 1 .705.03l2.214 2.213c.192.192.205.5.03.706l-1.926 2.276c.373.652.66 1.344.857 2.064l2.969.248zm-.565 3.17v-2.17l-2.863-.24a.521.521 0 0 1-.466-.404 7.745 7.745 0 0 0-1.013-2.44.522.522 0 0 1 .042-.616l1.858-2.196-1.535-1.534-2.195 1.858a.524.524 0 0 1-.616.042 7.765 7.765 0 0 0-2.44-1.013.523.523 0 0 1-.405-.466l-.239-2.863h-2.17l-.239 2.864a.522.522 0 0 1-.405.466 7.76 7.76 0 0 0-2.44 1.013.524.524 0 0 1-.616-.043l-2.195-1.858-1.535 1.535 1.858 2.195a.522.522 0 0 1 .042.616 7.772 7.772 0 0 0-1.013 2.44.522.522 0 0 1-.466.405l-2.863.239v2.17l2.863.239a.521.521 0 0 1 .466.405 7.745 7.745 0 0 0 1.013 2.44.523.523 0 0 1-.042.616l-1.858 2.195 1.535 1.535 2.195-1.858a.522.522 0 0 1 .616-.042 7.765 7.765 0 0 0 2.44 1.013c.222.05.387.239.405.466l.239 2.863h2.17l.239-2.864a.522.522 0 0 1 .405-.466 7.76 7.76 0 0 0 2.44-1.013.522.522 0 0 1 .616.043l2.195 1.858 1.535-1.535-1.858-2.195a.523.523 0 0 1-.042-.616 7.767 7.767 0 0 0 1.013-2.44.522.522 0 0 1 .466-.405l2.863-.239z"
  })), _react["default"].createElement("use", {
    transform: "translate(-8 -8)",
    xlinkHref: "#eb-cog_svg__a"
  }));
};

var _default = SvgEbCog;
exports["default"] = _default;